/// <amd-module name="Dashboards/Samples/dashboards-samples-page" />
import * as Resources from "Dashboards/Samples/Resources";
import * as React from "react";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Header, TitleSize } from "VSSUI/Header";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { Page } from "VSSUI/Page";
import { ITabProviderContext, Tab, TabBar, TabProviderContext } from "VSSUI/Tabs";
import { CatalogConfigSample } from "./CatalogConfigSample";
import { WidgetHostSample } from "./WidgetHostSample";
import { WidgetListPanelSample } from "./WidgetListPanelSample";

/**
 * This sample provides a limited gallery experience to review available Dashboard SDK features.
 */
class DashboardsSamplesView extends VssComponent {
    private static catalogConfigTabId = "catalogConfig";
    private static WidgetListPanelTabId = "inSituWidgets";
    private static widgetHostTabId = "widgetHost";
    private hubViewState: VssHubViewState;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this.hubViewState = new VssHubViewState(context.pageContext, {
            defaultPivot: DashboardsSamplesView.catalogConfigTabId
        });
    }

    public render(): JSX.Element {
        return (
            <Page selectedTabId={this.hubViewState.selectedPivot} className="flex-grow reporting-samples-container">
                <Header className="flex-noshrink" title={Resources.Title} titleSize={TitleSize.Medium} />
                <TabBar onSelectedTabChanged={this.onSelectedTabChanged}>
                    <Tab id={DashboardsSamplesView.catalogConfigTabId} name={Resources.CatalogConfigPivot} />
                    <Tab id={DashboardsSamplesView.widgetHostTabId} name={Resources.WidgetHostPivot} />
                    <Tab id={DashboardsSamplesView.WidgetListPanelTabId} name={Resources.WidgetListPivot} />
                </TabBar>
                <TabProviderContext.Consumer>
                    {(tabProviderContext: ITabProviderContext) => {
                        if (tabProviderContext.selectedId === DashboardsSamplesView.catalogConfigTabId) {
                            return (
                                <div className="page-content page-content-top">
                                    <CatalogConfigSample />
                                </div>
                            );
                        }
                        if (tabProviderContext.selectedId === DashboardsSamplesView.widgetHostTabId) {
                            return (
                                <div className="page-content page-content-top">
                                    <WidgetHostSample />
                                </div>
                            );
                        }
                        if (tabProviderContext.selectedId === DashboardsSamplesView.WidgetListPanelTabId) {
                            return (
                                <div className="page-content page-content-top">
                                    <WidgetListPanelSample />
                                </div>
                            );
                        }
                    }}
                </TabProviderContext.Consumer>
            </Page>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.hubViewState.selectedPivot.value = newTabId;
    };
}

Components.add("Dashboards-sample-view", DashboardsSamplesView);
